import * as React from "react";
import { Checkbox as BootstrapCheckbox } from "react-bootstrap";
import { useEffect, useRef } from "react";
const Checkbox = ({ onChange, indeterminate = false, ...props }, forwardedRef) => {
  const internalRef = useRef(null);
  const checkboxRef = forwardedRef || internalRef;
  useEffect(() => {
    if (checkboxRef.current && checkboxRef.current.indeterminate !== indeterminate) {
      checkboxRef.current.indeterminate = indeterminate;
    }
  }, [checkboxRef, indeterminate]);
  return /* @__PURE__ */ React.createElement(
    BootstrapCheckbox,
    {
      onChange,
      inputRef: (ref) => {
        checkboxRef.current = ref;
      },
      ...props
    }
  );
};
export default React.forwardRef(Checkbox);
